import Typography from '@ixigo/iui/Typography';
import type { DateTime } from '@/api';

export interface LocationSubtextProps {
	/** The label text (e.g., "Pickup", "Drop") */
	label: string;
	/** The time text */
	time: DateTime;
	/** Custom class name */
	className?: string;
}

export function LocationSubtext({
	label,
	time,
	className,
}: LocationSubtextProps) {
	return (
		<div className={`flex items-center gap-[5px] line-clamp-1 ${className}`}>
			<Typography
				variant="body-sm"
				className="text-secondary overflow-hidden text-ellipsis"
			>
				{label}
			</Typography>
			<Typography
				variant="body-sm"
				fontWeight="medium"
				className="overflow-hidden text-ellipsis"
			>
				{time.formattedDateTime.time}&nbsp;•&nbsp;{time.formattedDateTime.date}
			</Typography>
		</div>
	);
}

export default LocationSubtext;
